// extracted by mini-css-extract-plugin
export var deleteIcon = "_sv-5";
export var deleteOption = "_sv-3";
export var divider = "_sv-2";
export var downloadIcon = "_sv-4";
export var drawer = "_sv-0";
export var drawerFooter = "_sv-6";
export var drawerOpen = "_sv-1";
export var highlighted = "_sv-7";
export var lighterHighlight = "_sv-8";